module.exports = ".widget {\n  height: 400px; }\n\n.count {\n  font-size: 4em; }\n\n.row {\n  height: 100%; }\n\n.center-vertical {\n  margin-top: 2em; }\n\n.center-vertical h2 {\n    margin-bottom: 2.5rem; }\n\n.center-vertical h3 {\n    margin-top: 1.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/observations/widgets/observation-status/observation-status.component.scss
// module id = ./apps/eyewatch/src/app/eyewatch/observations/widgets/observation-status/observation-status.component.scss
// module chunks = main